<template>
  <div id="Subject">
    <el-dialog
      :title="titlename"
      width="650px"
      append-to-body
      @close="closeDialog"
      :visible.sync="visible"
      :show="show"
      :close-on-click-modal="false"
    >
      <div>
        <el-table
          :data="tableData"
          @cell-dblclick="celldblclick"
          height="250"
          border
          style="width: 100%"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}"
          :row-style="{fontSize:'16px',height:'37px',padding:'0'}"
        >
          <el-table-column width="80" align="center" fixed="left" label="行号">
            <template slot-scope="scope">{{scope.$index +1 }}</template>
          </el-table-column>
          <el-table-column width="50" align="center" label="类型">
            <template slot-scope="scope">
              <i
                :class="scope.row.IsDir?'el-icon-folder':'el-icon-tickets'"
                style="color:#e9cb70;font-size:18px"
              ></i>
            </template>
          </el-table-column>
          <el-table-column prop="UserCode" label="科目编号" align="center" width="180"></el-table-column>
          <el-table-column prop="FullName" label="科目名称" align="center" width="180"></el-table-column>
          <el-table-column prop="StopedName" label="状态" align="center"></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPages"
          :page-sizes="[10, 20,50,100]"
          :page-size="pageSizes"
          layout="total, sizes,prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tool from "@/utils/tool.js";
export default {
  name: "Subject",
  data() {
    return {
      visible: this.show,
      titlename: this.title,
      currentPages: 1, //当前页码
      totals: 0, //总页数
      pageSizes: 10, //每页显示数量
      ObtainHeader: [
        {
          BaseNo: 723,
          Model: "Subject",
          Type: 2,
          Key: "UserCode",
          Name: "科目编号",
          Rename: "科目编号",
          No: 1,
          ReNo: 1
        },
        {
          BaseNo: 724,
          Model: "Subject",
          Type: 2,
          Key: "FullName",
          Name: "科目名称",
          Rename: "科目名称",
          No: 2,
          ReNo: 2
        },
        {
          BaseNo: 725,
          Model: "Subject",
          Type: 2,
          Key: "StopedName",
          Name: "状态",
          Rename: "状态",
          No: 3,
          ReNo: 3
        }
      ],
      tableData: []
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    styleS: Number,
    title: {
      type: String,
      default: "科目类型"
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSizes = val;
      this.initialize();
    },
    handleCurrentChange(val) {
      this.currentPages = val;
      this.initialize();
    },
    // 双击一行
    rowdblclick(obj) {
      this.$emit("dblclick", obj);
    },
    // 关闭弹出框前回调
    closeDialog() {
      this.$emit("update:show", false);
      this.search = "";
    },
    celldblclick(val) {
      this.visible = false;
      this.$emit("celldblclick", val);
    },
    initialize() {
      let jparams = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        style: this.styleS,
        pagesize: this.pageSizes,
        pagenum: this.currentPages,
        type: 1
      };
      this.request
        .post("/index/Subject/search", {
          jparams: JSON.stringify(jparams)
        })
        .then(res => {
          let { status, description, data } = res;
          if (status == 0) {
            this.tableData = data;
          }
        });
    }
  },
  created() {
    // this.initialize();
  },
  watch: {
    show() {
      this.visible = this.show;
      if (this.visible == true) {
        this.initialize();
      }
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Dialog/Subject/Subject.vue